// Labels for the expandable Invoice History row (Accounting). Pure, no React.
// Amounts always come from the invoice's own line_items (what the PDF prints);
// the booking record only adds context (dates, size, page, rep, creative).

const CATEGORY_LABELS = { digital_edition: 'Print / digital edition', website: 'Website' };

const fmtDay = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatDay = fmtDay;

// When the ad runs: edition publish date, or the website date / date range.
export const scheduleLabel = (line) => {
  const bk = (line && line.booking) || {};
  if (bk.category === 'website' || bk.digital_start_date) {
    const s = bk.digital_start_date, e = bk.digital_end_date;
    if (s && e && e !== s) return `${fmtDay(s)} – ${fmtDay(e)}`;
    if (s) return fmtDay(s);
    return '';
  }
  return bk.publish_date ? fmtDay(bk.publish_date) : '';
};

export const taxLabel = (line) => {
  if (!line || !line.is_taxable) return 'No tax';
  const r = Number(line.tax_rate);
  return r > 0 ? `${r}%` : 'Taxable';
};

// Short facts about the booking behind a billed line, in display order.
export const bookingFacts = (line) => {
  const bk = line && line.booking;
  if (!bk) return [];
  const out = [];
  if (bk.category) out.push(CATEGORY_LABELS[bk.category] || bk.category);
  if (bk.size) out.push(`Size ${bk.size}`);
  else if (bk.width && bk.height) out.push(`${bk.width} × ${bk.height}`);
  if (bk.page_number) out.push(`Page ${bk.page_number}${bk.position ? ` (${bk.position})` : ''}`);
  else if (bk.page_preference) out.push(`Page pref. ${bk.page_preference}`);
  if (bk.sales_rep_name) out.push(`Rep: ${bk.sales_rep_name}`);
  if (bk.needs_factura) out.push('Needs factura');
  if (bk.creative_filename) out.push(`Creative: ${bk.creative_filename}`);
  if (bk.digital_schedule_notes) out.push(bk.digital_schedule_notes);
  return out;
};

// Fallback when the details call has not returned (or failed): the invoice's
// own lines, with no booking context.
export const linesFromInvoice = (invoice) =>
  ((invoice && invoice.line_items) || []).map((li) => ({ ...li, booking: null, booking_missing: false }));

export const editionsFromLines = (lines) => {
  const out = [];
  (lines || []).forEach((l) => {
    const n = l && l.edition_name;
    if (n && n !== 'N/A' && !out.includes(n)) out.push(n);
  });
  return out;
};

const METHOD_LABELS = {
  cash: 'Cash', bank_transfer: 'Bank transfer', check: 'Check', credit_card: 'Credit card', other: 'Other',
};
export const paymentMethodLabel = (m) => METHOD_LABELS[m] || m || '';
